import React from "react";
import "./SelectFilter.scss";
class SelectFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      options: props.options,
      label: props.label ? props.label : "Geography",
      type: props.type ? props.type : "Geography",
      onFilterSelection: props.onFilterSelection,
      selected: props.selected,
    };
    this.onFilterSelection = this.onFilterSelection.bind(this);
  }
  render() {
    const selected =
      this.props.selected === null ? "View All" : this.props.selected;
    return (
      <div className="form-group filterGroup">
        <label className="form-text-label" htmlFor={this.state.type}>
          <h2>{this.state.label}</h2>
        </label>
        <select
          name={this.state.type}
          id={this.state.type}
          onChange={this.onFilterSelection}
          className="form-control"
          value={selected}
        >
          {this.state.options.map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
          ;
        </select>
      </div>
    );
  }
  onFilterSelection(e) {
    const retVal = {
      filter: e.target.value,
      type: this.state.type,
    };
    this.props.onFilterSelection(retVal);
  }
}
export default SelectFilter;
